import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import { BackPage, Forms, OrderBar } from 'components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';

const AddNewAddress = () => {
  let query = useQuery();
  const history = useHistory();
  const prepopFormValues = useSelector((state) => state.addressForm);
  const [initialValues, setInitialValues] = useState({
    nickname: '',
    address_line1: '',
    address_line2: '',
    city_town: '',
    county: '',
    postcode: '',
  });
  const [formReady, setFormReady] = useState(false);
  const accountView = query.get('view') === 'account' ? true : false;

  useEffect(() => {
    if (prepopFormValues.populated) {
      setInitialValues({
        nickname: '',
        address_line1: prepopFormValues.address_line1,
        address_line2: '',
        city_town: prepopFormValues.city_town,
        county: prepopFormValues.county,
        postcode: prepopFormValues.postcode,
      });
    }
    setFormReady(true);
  }, [prepopFormValues]);

  return (
    <>
      {!accountView && <OrderBar currentProgress={0} />}
      <BackPage onBackClick={() => history.goBack()}>
        <h1 className={styles.header}>Add new address</h1>
        <p className={styles.subheader}>When your order is approved, we can send to any UK address.</p>
        {formReady && (
          <Forms.AddNewAddressForm
            initialValues={initialValues}
            redirect={
              accountView ? '/pharmacy/dashboard/delivery-details?view=account' : '/pharmacy/dashboard/delivery-details'
            }
            saveAddress={!accountView}
          />
        )}
      </BackPage>
    </>
  );
};

export default AddNewAddress;
